import ModalTriggerProvider from './hooks/useModalTrigger';

import { ModalTriggerProps } from './@types/ModalTriggerProps';
import HandleModalProvider from './hooks/useHandleModal';
import { useState } from 'react';

const ModalTrigger = (props: ModalTriggerProps) => {
	//colocando is open como true para poder manipular o estado fora do click (simular abrir na home etc)
	const [isOpen, setIsOpen] = useState(props.trigger == 'click' ? false : true);

	return (
		<HandleModalProvider isOpen={isOpen} setIsOpen={setIsOpen} triggerComponentId={props?.componentId}>
			<ModalTriggerProvider {...props}>
				<div
					role="button"
					onClick={(e: any) => {
						setIsOpen(!isOpen);
					}}
					data-selection={props?.componentId}
					className={`triggerContainer triggerContainer--${props.blockClass} bg-transparent pa0 bw0 dib`}
				>
					{props.children}
				</div>
			</ModalTriggerProvider>
		</HandleModalProvider>
	);
};

export default ModalTrigger;
